import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import {
  CreateOrderService,
  OrderService,
  UpdateOrderService
} from "src/app/backend/models/order-service";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { environment } from "src/environments/environment";

@Injectable()
export class OrderServiceBackend {
  constructor(private http: HttpClient) {}

  load(id: string, light?: boolean): Observable<OrderService> {
    return this.http.get<OrderService>(
      `${environment.snoots.api.store}/services/${id}`,
      {
        params: light ? { light: "true" } : {}
      }
    );
  }

  list({
    page,
    pageSize,
    filterValues
  }: PageRequest): Observable<PaginatedResult<OrderService>> {
    return this.http.get<PaginatedResult<OrderService>>(
      `${environment.snoots.api.store}/services`,
      {
        params: {
          p: page?.toString() ?? "",
          s: pageSize?.toString() ?? "",
          ...filterValues
        }
      }
    );
  }

  @UserNotify({
    successMessage: marker("Servizio creato"),
    errorMessage: marker("Impossibile creare il servizio")
  })
  create(payload: CreateOrderService): Observable<OrderService> {
    return this.http.post<OrderService>(
      `${environment.snoots.api.store}/services`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Servizio aggiornato"),
    errorMessage: marker("Impossibile aggiornare il servizio")
  })
  update(id: string, payload: UpdateOrderService): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.store}/services/${id}`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Servizio eliminato"),
    errorMessage: marker("Impossibile eliminare il servizio")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.store}/services/${id}`
    );
  }
}
